import { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import NameSearch from '../components/NameSearch';
import NameMatches from '../components/NameMatches';
import Layout from '../components/Layout';
import AdBlockDetector from '../components/AdBlockDetector';
import QuotesByCategory from '../components/QuotesByCategory';
import FAQ from '../components/FAQ';
import AdBanner from '../components/AdBanner';
import Tutorial from '../components/Tutorial';
import { DynamicSEO } from '../components/seo';

export default function HomePage() {
  const [activeTab, setActiveTab] = useState<'search' | 'matches'>('search');

  return (
    <Layout>
      <DynamicSEO 
        meta={{
          title: "Discover Name Meanings - Find the Meaning of Names in Nepali & English",
          description: "Explore Nepali name meanings, find perfect name matches, and discover traditional wisdom.",
          type: "website"
        }}
      />
      
      <Tutorial />
      <AdBlockDetector />
      
      <Header activeTab={activeTab} onTabChange={setActiveTab} />
      
      <main className="pb-16">
        {activeTab === 'search' ? <NameSearch /> : <NameMatches />}
      </main>

      <QuotesByCategory />
      <FAQ />
      <AdBanner />
    </Layout>
  );
}